import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  // checking
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface">
        <div className="text-navy font-heading text-lg">
          <i className="fa-solid fa-spinner fa-spin mr-2" />
          Verificando sessão...
        </div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
